import { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { Lock } from 'lucide-react';

export default function AdminLogin() {
  const { login, token } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  if (token) return <Navigate to="/admin/dashboard" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) { toast.error('Bitte alle Felder ausfüllen'); return; }
    setLoading(true);
    try {
      await login(username, password);
      toast.success('Erfolgreich angemeldet');
      navigate('/admin/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Anmeldung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F7F9FC] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#0E518D] rounded-sm flex items-center justify-center mx-auto mb-4">
            <Lock className="h-7 w-7 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-[#0E518D]">Admin Login</h1>
          <p className="text-sm text-[#475569] mt-1">GB Sylt Bestellwelt</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white rounded-sm shadow-sm border border-slate-100 p-8 space-y-5">
          <div>
            <Label className="text-sm font-medium text-[#1E293B]">Benutzername / E-Mail</Label>
            <Input value={username} onChange={e => setUsername(e.target.value)} className="mt-1 rounded-sm" placeholder="admin" autoFocus data-testid="login-username" />
          </div>
          <div>
            <Label className="text-sm font-medium text-[#1E293B]">Passwort</Label>
            <Input type="password" value={password} onChange={e => setPassword(e.target.value)} className="mt-1 rounded-sm" placeholder="Passwort" data-testid="login-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#0E518D] hover:bg-[#0B4171] text-white rounded-sm uppercase tracking-wide font-medium" data-testid="login-submit">
            {loading ? 'Anmeldung...' : 'Anmelden'}
          </Button>
        </form>
      </div>
    </div>
  );
}
